
import { getPropertyByKey } from '../../helper/utils/getPropertyByKey';
import { isEmptyObject } from '../../helper/utils/isEmptyObject';
import { getItemsNoVoid, getPriceMenuTax } from './menuItem';
import { manualRounded } from './rounded';
import { serviceValueMenu } from './service';

export function isTax(salesOrderData = {}) {
    if (isEmptyObject(salesOrderData)) {
        return false;
    }

    return salesOrderData['cTax'] === true;
}

export function isServiceTaxable() {
    return getPropertyByKey('ServisTaxable') == true; //* Ambil dari proeprty
}

export function isTaxBeforeDiscount() {
    return getPropertyByKey('TaxBeforeDiskon') == true; //* Ambil dari proeprty
}

export function taxPrc() {
    return parseFloat(getPropertyByKey('TaxPrc') || '0'); //* Ambil dari proeprty
}

export function showTaxPrconBill() {
    return getPropertyByKey('TaxPrcOnBill') == 1;
}

export function taxValueMenu(menu = {}, salesOrderData = {}) {
    if (isEmptyObject(menu) || !(isTax(salesOrderData) && menu['cTax'] == true)) {
        return 0;
    }

    const price = parseFloat(menu[`Price${salesOrderData['SalesTypeCode']}`].toString()) || 0;
    const qty = parseFloat((menu['qty'] || 0).toString()) || 0;
    const discVal = parseFloat((menu['discVal'] || 0).toString()) || 0;
    const serviceValue = serviceValueMenu(menu, salesOrderData);

    if (qty == 0) {
        return 0;
    }

    //* Kalkulasi harga tax sebelum diskon
    if (isTaxBeforeDiscount()) {
        const amountBeforeDisc = qty * price;

        if (isServiceTaxable()) {
            // return Math.round((amountBeforeDisc + serviceValue) * (taxPrc() / 100));
            // return (amountBeforeDisc + serviceValue) * (taxPrc() / 100);

            return manualRounded((amountBeforeDisc + serviceValue) * (taxPrc() / 100));
        } else {
            // return Math.round(amountBeforeDisc * (taxPrc() / 100));
            // return amountBeforeDisc * (taxPrc() / 100);
            return manualRounded(amountBeforeDisc * (taxPrc() / 100));
        }
    } else {
        const amountAfterDisc = (price - discVal) * qty;

        if (isServiceTaxable()) {
            // return Math.round((amountAfterDisc + serviceValue) * (taxPrc() / 100));
            // return (amountAfterDisc + serviceValue) * (taxPrc() / 100);
            return manualRounded((amountAfterDisc + serviceValue) * (taxPrc() / 100));
        } else {
            // return Math.round(amountAfterDisc * (taxPrc() / 100));
            // return amountAfterDisc * (taxPrc() / 100);
            return manualRounded(amountAfterDisc * (taxPrc() / 100));
        }
    }
}

export function totalTaxValue(items = [], salesOrderData = {}) {
    if (items.length > 0) {
        if (isTax(salesOrderData)) {
            const taxes = getItemsNoVoid(items)?.map((item) => getPriceMenuTax(item));
            const tax = taxes.reduce((a, b) => parseFloat(a.toString()) + parseFloat(b.toString()), 0);

            // return Math.round(tax);
            return tax;
        }
    }

    return 0;
}
